import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { exercise, exercisesData, createExercise } from '../mockData/exercise-log-data';

const ExerciseLogsApi = [
  rest.get(`${API_ROOT}exercise-logs`, (req, res, ctx) => {
    const limit = req.url.searchParams.get('$limit');
    const skip = req.url.searchParams.get('$skip');
    if (limit === '10' && skip === '0') {
      return res(ctx.json(exercise));
    }
    return res(ctx.json({ data: [] }));
  }),
  rest.post(`${API_ROOT}exercise-logs/`, (req, res, ctx) => res(ctx.json(createExercise))),
  rest.get(`${API_ROOT}exercises`, (req, res, ctx) => res(ctx.json(exercisesData))),
  rest.get(`${API_ROOT}nutritionix/exercise`, (req, res, ctx) => {
    const query = req.url.searchParams.get('query');
    if (query === `'${createExercise.name} for ${createExercise.duration} min'`) {
      return res(ctx.json(createExercise.caloriesBurned));
    }
    return res(ctx.json(0));
  }),
  rest.get(`${API_ROOT}exercise-logs`, (req, res, ctx) => {
    const limit = req.url.searchParams.get('$limit');
    const skip = req.url.searchParams.get('$skip');
    const patientId = req.url.searchParams.get('patientId');
    if (patientId && limit && skip) {
      return res(ctx.json({ total: 0, data: [] }));
    }
    return res(ctx.json());
  }),
  rest.delete(`${API_ROOT}exercise-logs/${exercise.data[0].id}`, (req, res, ctx) => res(ctx.json({ data: {} }))),
];
export default ExerciseLogsApi;
